<!-- 
Snackbar for displaying transient notifications.

Used for confirmations of the "saved successfully" variety. Can be dismissed by clicking a button, or
will dismiss itself after a few seconds.
-->
<template>
  <v-snackbar :value="notifications.show" :multi-line="true" @input="hideNotification">
    {{ notifications.text }}
    <v-btn color="pink" flat @click="hideNotification">
      Close
    </v-btn>
  </v-snackbar>
</template>

<script>
import { HIDE_NOTIFICATION } from "@/store/notifications/mutation-types";

export default {
  computed: {
    notifications() {
      return this.$store.state.notifications;
    }
  },
  methods: {
    hideNotification() {
      this.$store.commit(HIDE_NOTIFICATION);
    }
  }
};
</script>
